



























































































































































































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  data: () => ({
    menuDate: false,
    menuPeriod: false,
    rules: [(v) => v.length <= 50 || 'Max 50 characters'],
    date: '',
    period: '',
    openDialog: false,
    openDialog1: false,
    headers: [
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Concepto', value: 'concepto.nombre' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Precio unitario', value: 'unitario' },
      { text: 'Importe', value: 'importe' },
    ],
    items: [
    ],
    nuevoItem: {
      key: '',
      concepto: {},
      descripcion: '',
      unidadDeMedida: '',
      cantidad: 0,
      unitario: 0,
      impuesto: '',
      impuestos: {
        baseImp: 0,
        importeImp: 0,
        imp: {},
      },
      importe: 0,
      openTotal: 0,
      pagoStatus: 0,
    },
    Recibo: {
      administracion: {},
      condominio: {},
      unidad: {},
      propietario: {},
      items: [],
      subtotal: 0,
      tipoDeComprobante: '',
      total: 0,
      fechaDeEmision: '',
      folio: '',
      serie: '',
      totalImpuestos: 0,
    },
    loading: false,
    result: {},
    var: 0,
    unidades: [],
    conceptos: [],
    conceptosTemp: [],
    asociar: false,
    propietarios: [],
    total: 0,
    selected: [],
    isSelectedEmpty: true,
    precision: 2,
    formatoFecha: 'DD/MM/YYYY',
    formatPeriod: 'MM/YYYY',
    options: {},
    unidadesPropietarios: [],
    unidadPropietario: {},
    series: [],
    key: 0,
    selectedConcepto: {},
    // tipoDeComprobante: [{name: 'INGRESO'}, {name: 'EGRESO'}],
    tipoDeComprobante: [{name: 'INGRESO'}],
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    computedPeriodFormatted() {
      return this.$moment(this.period).format(this.formatPeriod);
    },
    nuevoItemImporte() {
      if (!isNaN(this.nuevoItem.cantidad * this.nuevoItem.unitario)) {
        return (this.nuevoItem.cantidad * this.nuevoItem.unitario).toFixed(this.precision);
      } else {
        return (0).toFixed(this.precision);
      }
    },
  },
  methods: {
    restrictChars($event, e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) ||
          ($event.charCode === 46) && (e.indexOf('.') === -1) ) {
        return true;
      } else {
          $event.preventDefault();
      }
    },
    async loadData() {
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const datos = {admin, condo};
      // console.log('getUnidadesPropListMax datos: %o', datos);
      const unidades = this.$store.dispatch('getUnidadesPropListMax', {datos})
        .then((response) => {
               // console.log('getUnidadesPropListMax response: %o', response);
               this.unidadesPropietarios = response.content;
               this.createUniPropLabels(this.unidadesPropietarios);
               console.log('unidadesPropietarios: ', this.unidadesPropietarios); })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });

      const conceptos = this.$store.dispatch('getConceptoList1', {datos})
        .then((result) => {console.debug('getConceptoList1 response: %o', result.content);
                           this.conceptos = result.content; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });

      const series = this.$store.dispatch('getSeriesList', datos)
        .then((response) => {console.log('getSeriesList response: %o', response);
                             this.series = response; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
      Promise.all([unidades, conceptos, series])
        .then((values) => this.loading = false);
    },
    close() {
      this.openDialog1 = false;
      setTimeout(() => {
        this.nuevoItem = this.modeloNuevoItem();
        // this.nuevoItem.importe = 0;
        // this.nuevoItem.concepto = {};
        this.selectedConcepto = {};
      }, 300);
    },
    closeRecibo() {
      this.openDialog = false;
      this.Recibo = {
        subtotal: 0,
        totalImpuestos: 0,
        total: 0,
      };
      this.unidadPropietario = {};
      this.total = 0;
      this.items = Object.assign([]);
      this.key = 0;
      // this.date = this.$moment().format();
    },
    AgregarConcepto() {
      console.log('ConceptoDescripcion %o', this.nuevoItem.concepto);
      if (!this.isConceptoValid(this.selectedConcepto)) {
        this.$toast.error('Seleccione un concepto');
        return;
      }
      this.key++;
      this.nuevoItem.key = this.key;
      this.nuevoItem.cantidad = Number(this.nuevoItem.cantidad);
      this.nuevoItem.unitario = Number(this.nuevoItem.unitario);
      this.nuevoItem.importe = (this.nuevoItem.cantidad * this.nuevoItem.unitario).toFixed(this.precision);
      this.nuevoItem.impuestos.baseImp = this.nuevoItem.importe;
      this.nuevoItem.impuestos.importeImp = (this.nuevoItem.importe * this.nuevoItem.impuestos.imp.tasa)
        .toFixed(this.precision);
      this.nuevoItem.openTotal = Number(this.nuevoItem.importe) + Number(this.nuevoItem.impuestos.importeImp);
      this.nuevoItem.pagoStatus = 0;
      this.items.push(this.nuevoItem);
      const totales = this.getTotals(this.items);
      this.Recibo.subtotal = totales.subtotal.toFixed(this.precision);
      this.Recibo.totalImpuestos = totales.totalImpuestos.toFixed(this.precision);
      this.Recibo.total = totales.total.toFixed(this.precision);
      this.close();
    },
    isConceptoValid(concepto) {
      if (Object.keys(concepto).length > 0) {
        return true;
      }
      return false;
    },
    getSubtotal(items) {
      let subtotal = 0;
      for (const item of items) {
        if (!item.concepto.adeudo) {
          subtotal += Number(item.impuestos.baseImp);
        }
      }
      return subtotal;
    },
    getTotalImpuestos(items) {
      let importeImp = 0;
      for (const item of items) {
        if (!item.concepto.adeudo) {
          importeImp += Number(item.impuestos.importeImp);
        }
      }
      return importeImp;
    },
    getTotals(items) {
      const returnObject = {
        subtotal: 0,
        totalImpuestos: 0,
        total: 0,
      };
      const subtotal = this.getSubtotal(items);
      const totalImpuestos = this.getTotalImpuestos(items);
      const total = subtotal + totalImpuestos;
      returnObject.subtotal = subtotal;
      returnObject.totalImpuestos = totalImpuestos;
      returnObject.total = total;
      return returnObject;
    },
    async AgregarRecibo() {
      if (this.unidadPropietario && this.Recibo.serie && this.items.length > 0 && this.Recibo.tipoDeComprobante) {
        try {
          this.loading = true;
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const propietario = {id: this.unidadPropietario.propId};
          const datos = {admin, condo, propietario};
          console.log('getPropietarioById datos: %o', datos);
          const response = await this.$store.dispatch('getPropietarioById', datos);
          console.log('getPropietarioById response: %o', response);
          this.Recibo.propietario = response.data;
        } catch (e) {
          console.error(e);
          // this.$toast.error(e);
          this.$toast.error(e.response.data.message);
        }
        try {
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const unidad = {id: this.unidadPropietario.unidadId};
          const datos = {admin, condo, unidad};
          console.log('getUnidadById datos: %o', datos);
          const response = await this.$store.dispatch('getUnidadById', datos);
          console.log('getUnidadById response: %o', response);
          this.Recibo.unidad = response.data;
        } catch (e) {
          console.error(e);
          // this.$toast.error(e);
          this.$toast.error(e.response.data.message);
        }
        try {
          this.Recibo.creationDateTime = this.$moment().format();
          this.Recibo.creationUsername = this.$store.getters.getUsername;
          this.Recibo.pagoStatus = 'NOPAGADO';
          this.Recibo.administracion = this.$store.getters.getAdmin;
          this.Recibo.condominio = this.$store.getters.getCondo;
          this.Recibo.items = this.items;
          const totales = this.getTotals(this.items);
          this.Recibo.subtotal = totales.subtotal.toFixed(this.precision);
          this.Recibo.totalImpuestos = totales.totalImpuestos.toFixed(this.precision);
          this.Recibo.total = totales.total.toFixed(this.precision);
          this.Recibo.fechaDeEmision = this.$moment(this.date).format();
          this.Recibo.periodo = this.$moment(this.period).format();

          console.log('addRecibo Recibo: %o', this.Recibo);
          const result = await this.$store.dispatch('addRecibo', {datos: this.Recibo});
          console.log('addRecibo result: %o', result);
          this.$toast.success('Recibo Agregado exitosamente');
        } catch (e) {
          console.error(e);
          // this.$toast.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.loading = false;
        this.closeRecibo();
        this.$emit('reload', {});
      } else {
        this.$toast.error('El recibo requiere unidad/propietario, serie, Tipo Comprobante y al menos un concepto');
      }
    },
    rowSelected(event) {
      const boolAndIndex = this.isConceptoInArray(event, this.selected);
      const isInSelected = boolAndIndex.boolValue;
      const index = boolAndIndex.index;
      if (isInSelected) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(event);
      }
    },
    isConceptoInArray(concepto, conceptosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const con of conceptosArray) {
        if (con.key === concepto.key) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
    eliminarItems() {
      console.log('Key %o', this.selected);
      for (const item of this.selected) {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1);
      }
      const totales = this.getTotals(this.items);
      this.Recibo.subtotal = totales.subtotal;
      this.Recibo.totalImpuestos = totales.totalImpuestos;
      this.Recibo.total = totales.total;
      this.selected = [];
    },
    modeloNuevoItem() {
      return {
        key: '',
        concepto: {},
        descripcion: '',
        unidadDeMedida: '',
        cantidad: 0,
        unitario: 0,
        impuestos: {
          baseImp: 0,
          importeImp: 0,
          imp: {},
        },
        importe: 0,
      };
    },
    createUniPropLabels(uniPropArray) {
      for (const uniProp of uniPropArray) {
        const label = uniProp.nombreUnidad + ' / ' + uniProp.nombreInquilino;
        uniProp.label = label;
      }
    },
  },
  watch: {
    items() {
      this.total = this.items.length;
    },
    selected() {
      if (this.selected.length === 0) {
        this.isSelectedEmpty = true;
      } else {
        this.isSelectedEmpty = false;
      }
    },
    selectedConcepto(event) {
      if (Object.keys(event).length > 0) {
        this.nuevoItem.concepto = event;
        this.nuevoItem.impuestos.imp = event.impuesto;
        this.nuevoItem.descripcion = event.descripcion;
        this.nuevoItem.impuesto = event.impuesto.descripcion;
        this.nuevoItem.unidadDeMedida = event.unidadMedida;
      }
    },
    openDialog() {
      this.loadData();
      this.date = this.$moment().format();
      this.period = this.date;
      console.log(this.date);
    },
  },
});
